try{self['workbox:expiration:4.1.1']&&_()}catch(e){}// eslint-disable-line